import {getField, updateField} from 'vuex-map-fields';
import isUndefined from 'lodash/isUndefined';
import find from 'lodash/find';
import clone from 'lodash/clone';
import {createOrder} from './api/order';
import {verifyVoucher} from './api/voucher';

export const workerFields = { name: null, surname: null, phone: null, email: null, additionalData: {} };

function getUrlVars() {
    let vars = {};
    window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
        vars[key] = value;
    });
    return vars;
}

export const ssvOrderModule = {
    namespaced: true,
    state:      {
        courseDate:                 null,
        course:                     null,
        trainingCenter:             null,
        participant:                {
            data: [clone(workerFields)]
        },
        parameters:                 {
            inGuild:         false,
            inGuildOriginal: false,
            note:            null,
        },
        billingInformation:         {
            name:                    null,
            address:                 null,
            zip:                     null,
            city:                    null,
            identificationNumber:    null,
            taxIdentificationNumber: null,
        },
        mailingInformation:         {
            anotherMailingAddress: false,
            address:               null,
            zip:                   null,
            city:                  null,
        },
        contactInformation:         {
            name:        null,
            surname:     null,
            phone:       null,
            email:       null,
            mktApproval: false,
        },
        beneficiaryInformation:     {
            name:    null,
            surname: null,
        },
        certificateCopyInformation: {
            certificateEvidenceNumber: null,
        },
        buildingCertification:      {
            name:                             null,
            address:                          null,
            city:                             null,
            realizationDate:                  null,
            expiredCertificateEvidenceNumber: null,
        },
        additionalData:             {
            numberOfBooks: 1,
            contactId:     null,
        },
        voucher:                    {
            data: null,
        },
        order:                      {
            data: null,
        },
        errors:                     [],
        gift:                       false,
    },
    getters:    {
        getField,

        // ADDITIONAL DATA
        numberOfBooks: (state) => state.additionalData.numberOfBooks,

        // BUILDING CERTIFICATIONS
        buildingCertification: (state) => state.buildingCertification,

        // COMPANY WORKERS
        numberOfParticipants: (state) => state.participant.data.length,
        participants:         (state) => state.participant.data,
        participantByIndex:   (state, getters) => (index) => getters.participants[index],

        // MAILING INFORMATION
        anotherMailingAddress: (state) => state.mailingInformation.anotherMailingAddress,

        // ERRORS
        errors:     (state) => state.errors,
        errorByKey: (state, getters) => (key) => {
            const error = find(getters.errors, ({ key }));
            return isUndefined(error) ? null : error;
        },

        // COURSE
        course:         (state) => state.course,
        courseId:       (state, getters) => getters.course ? getters.course.id : null,
        courseDate:     (state) => state.courseDate,
        courseDateId:   (state, getters) => getters.courseDate ? getters.courseDate.id : null,
        trainingCenter: (state) => state.trainingCenter,
        type:           (state, getters) => getters.course.type,

        // ORDER PARAMETERS
        createOrderParameters: (state, getters) => {
            return {
                participants:               getters.participants,
                buildingCertification:      state.buildingCertification,
                parameters:                 getters.parameters,
                mailingInformation:         state.mailingInformation,
                contactInformation:         state.contactInformation,
                beneficiaryInformation:     state.beneficiaryInformation,
                certificateCopyInformation: state.certificateCopyInformation,
                billingInformation:         state.billingInformation,
                courseDateId:               getters.courseDateId,
                courseId:                   getters.courseId,
                voucherId:                  getters.voucher ? getters.voucher.id : null,
                gift:                       getters.gift,
                additionalData:             state.additionalData
            }
        },

        // ORDER
        order:      (state) => state.order.data,
        parameters: (state) => ({
            inGuild:         state.parameters.inGuild,
            inGuildOriginal: state.parameters.inGuildOriginal,
            note:            state.parameters.note
        }),

        // VOUCHER
        voucher: (state) => state.voucher.data,

        // GIFT
        gift: (state) => state.gift,

    },
    actions:    {
        // COMPANY WORKERS
        increaseParticipant: ({ commit }) => commit('increaseParticipant'),
        decreaseParticipant: ({ commit }) => commit('decreaseParticipant'),
        setParticipantField: ({ commit }, data) => commit('setParticipantField', data),

        // MAILING INFORMATIONS
        clearMailingInformations: ({ commit }) => commit('clearMailingInformations'),

        // ERRORS
        clearErrors: ({ commit }) => commit('clearErrors'),
        setError:    ({ commit }, data) => commit('setError', data),

        // COURSE
        setCourse:         ({ commit }, course) => commit('setCourse', course),
        setCourseDate:     ({ commit }, courseDate) => commit('setCourseDate', courseDate),
        setTrainingCenter: ({ commit }, trainingCenter) => commit('setTrainingCenter', trainingCenter),

        // VOUCHER
        verifyVoucher: ({ commit, getters }, voucherCode) => verifyVoucher(getters.courseId, voucherCode)
        .then((data) => commit('setVoucher', data)),
        removeVoucher: ({ commit }) => commit('setVoucher', null),

        // GIFT
        setGift: ({ commit }, status) => commit('setGift', status),

        // ORDER
        createOrder: ({ commit, getters }) => createOrder(getters.createOrderParameters)
        .then((data) => commit('setOrder', data)),
    },
    mutations:  {
        updateField,

        // COMPANY WORKERS
        increaseParticipant: (state) => state.participant.data.push(clone(workerFields)),
        decreaseParticipant: (state) => state.participant.data.splice(state.participant.data.length - 1, 1),
        setParticipantField: (state, { index, name, value }) => state.participant.data[index][name] = value,

        // MAILING INFORMATION
        clearMailingInformations: (state) => {
            state.mailingInformation.address = null;
            state.mailingInformation.city = null;
            state.mailingInformation.zip = null;
        },

        // ERRORS
        clearErrors: (state) => state.errors.splice(0, state.errors.length),
        setError:    (state, data) => state.errors.push(data),

        // COURSE
        setCourse:         (state, course) => state.course = course,
        setCourseDate:     (state, courseDate) => state.courseDate = courseDate,
        setTrainingCenter: (state, trainingCenter) => state.trainingCenter = trainingCenter,

        // VOUCHER
        setVoucher: (state, data) => state.voucher.data = data,

        // GIFT
        setGift: (state, status) => state.gift = status,

        // ORDER
        setOrder: (state, data) => state.order.data = data,

    }
}



// WEBPACK FOOTER //
// ./src/components/ssv-order/store.js